import * as THREE from 'three';

// Island definitions from terrain-lab (normalized positions + angular radii)
const ISLAND_DEFS = [
  { pos: [ 0.58,  0.58,  0.58], radius: 0.50 },
  { pos: [-0.85,  0.30,  0.43], radius: 0.42 },
  { pos: [ 0.15, -0.90,  0.41], radius: 0.48 },
  { pos: [-0.40,  0.70, -0.59], radius: 0.38 },
  { pos: [ 0.90, -0.20, -0.39], radius: 0.44 },
  { pos: [-0.25, -0.55, -0.80], radius: 0.35 },
  { pos: [ 0.35,  0.25,  0.90], radius: 0.46 },
  { pos: [-0.70, -0.65,  0.30], radius: 0.40 },
].map(isl => {
  const [x, y, z] = isl.pos;
  const len = Math.sqrt(x * x + y * y + z * z);
  const nx = x / len;
  const ny = y / len;
  const nz = z / len;
  return {
    nx, ny, nz,
    theta: Math.atan2(nx, nz),
    phi: Math.acos(Math.max(-1, Math.min(1, ny))),
    angularRadius: isl.radius,
  };
});

export interface IslandInfo {
  nx: number;
  ny: number;
  nz: number;
  theta: number;
  phi: number;
  angularRadius: number;
}

/** Returns the 8 island definitions with unit normals and spherical coords. */
export function getIslands(): IslandInfo[] {
  return ISLAND_DEFS;
}

/**
 * Compute the land mask at a given unit-normal direction on the sphere.
 * Returns a value in [0, 1] where 0 = open ocean, 1 = island interior.
 */
export function computeLandMask(nx: number, ny: number, nz: number): number {
  let mask = 0;
  for (const isl of ISLAND_DEFS) {
    const dot = nx * isl.nx + ny * isl.ny + nz * isl.nz;
    const angle = Math.acos(Math.min(1, Math.max(-1, dot)));
    const t = 1 - angle / isl.angularRadius;
    if (t > mask) mask = t;
  }
  return Math.max(0, Math.min(1, mask));
}

/** Returns island 3D positions and angular radii for ocean wave damping */
export function getIslandData(oceanRadius: number) {
  return ISLAND_DEFS.map((isl) => ({
    position: new THREE.Vector3(isl.nx * oceanRadius, isl.ny * oceanRadius, isl.nz * oceanRadius),
    angularRadius: isl.angularRadius,
  }));
}
